import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// --- NetCast boot tracepoints (see index.html #__boot_diag overlay) ---------
// On the LG drive-through TV the app currently shows the boot overlay but never
// stamps ng-version, with NO thrown error -- a silent hang. These marks split
// the two remaining suspects apart on the next TV refresh, deterministically:
//   * if 'main.ts: es5 bundle executing' NEVER appears -> a blocking <head>
//     CDN <script> hung before the app bundle ran (network/TLS). The last
//     'head: * ok' mark names the culprit.
//   * if it appears but 'microtask flushed' never does -> zone.js/core-js@2
//     Promise microtask scheduling is dead on this engine (bootstrap resolves
//     via microtasks, so it can never complete).
//   * if microtasks flush but 'bootstrapModule RESOLVED' never fires -> the
//     hang is inside Angular init (e.g. an APP_INITIALIZER awaiting a request
//     that never returns).
// Every call is guarded and try/caught -- it can never itself break boot, and
// it is inert on modern devices (the app mounts and the overlay self-dismisses).
const __blog = (msg: string) => {
  try {
    const w = window as any;
    if (w && typeof w.__bootlog === 'function') { w.__bootlog(msg); }
  } catch (e) { /* diagnostics must never break boot */ }
};
__blog('main.ts: es5 bundle executing');
try {
  Promise.resolve().then(() => __blog('main.ts: microtask flushed (zone Promise OK)'));
  setTimeout(() => __blog('main.ts: macrotask fired (setTimeout OK)'), 0);
} catch (e) { /* probe only */ }

if (environment.production) {
  enableProdMode();
  const script = document.createElement('script');
  script.src = 'https://checkout.clover.com/sdk.js';
    document.body.appendChild(script);
} else {
  const script = document.createElement('script');
  script.src = 'https://checkout.sandbox.dev.clover.com/sdk.js';
  document.body.appendChild(script);
}

__blog('main.ts: calling bootstrapModule');
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => __blog('main.ts: bootstrapModule RESOLVED (Angular booted)'))
  .catch(err => {
    __blog('main.ts: bootstrap REJECTED: ' + (err && err.message ? err.message : err));
    console.error(err);
  });

